import './index.module.scss';

import { profitTypes } from 'live/components/index.shared';
import LiveInvite from 'live/components/LiveInvite';
import SelectedGamePopupAsyncApp from 'live/containers/SelectedGamePopup/SelectedGamePopupAsyncApp';
import TopProfitAsyncApp from 'live/containers/TopProfit/TopProfitAsyncApp';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators, compose } from 'redux';

import GamblingLiability from 'calendar/components/GamblingLiability';
import { AsyncDialogs as AsyncSportDialogs } from 'shared/components/AsyncSportApp';
import ErrorBoundary from 'shared/components/ErrorBoundary';
import ContentWrapper from 'shared/components/layout/ContentWrapper';
import PageBody from 'shared/components/layout/PageBody';
import PageMeta from 'shared/components/PageMeta';
import * as dialogTypes from 'shared/constants/DialogTypes';
import withAsyncReducers from 'shared/containers/withAsyncReducers';
import withContentMenu from 'shared/containers/withContentMenu';
import {
  showAtgArchiveDialog,
  showSportArchiveDialog,
} from 'shared/redux/actions';
import { dialogs, user } from 'shared/redux/selectors';
import { getText } from 'shared/utils/Text';

import Ad from './components/Ad';
import AtgContainer from './containers/AtgContainer';
import AtgSubscriptionGatekeeper from './containers/AtgSubscriptionGatekeeper';
import BetTipsContainer from './containers/BetTipsContainer';
import ContentContainer from './containers/ContentContainer';
import JackpotContainer from './containers/JackpotContainer';
import SportContainer from './containers/SportContainer';
import betTipsReducer from './redux/reducers/betTipsReducer';
import calendarReducer from './redux/reducers/calendarReducer';

const mapStateTopProps = state => ({
  isLoggedIn: user.isLoggedIn(state),
  isErrorDialogActive: dialogs.hasDialog(state, {
    dialogType: dialogTypes.ERROR,
  }),
  isAtgArchiveDialogActive: dialogs.hasDialog(state, {
    dialogType: dialogTypes.ATG_ARCHIVE,
  }),
  isSportArchiveDialogActive: dialogs.hasDialog(state, {
    dialogType: dialogTypes.SPORT_ARCHIVE,
  }),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showAtgArchiveDialog,
      showSportArchiveDialog,
    },
    dispatch,
  );

export default compose(
  withAsyncReducers({
    calendar: calendarReducer,
    betTips: betTipsReducer,
  }),
  withRouter,
  withContentMenu,
  connect(mapStateTopProps, mapDispatchToProps),
)(
  class JokerCalendar extends Component {
    state = {
      action: undefined,
      sidebarStatType: profitTypes[0],
    };

    UNSAFE_componentWillUpdate(nextProps, nextState) {
      const {
        isLoggedIn,
        history,
        location,
        showAtgArchiveDialog,
        showSportArchiveDialog,
      } = nextProps;

      const { action } = nextState;

      if (action) {
        const { showAtgArchive, showSportArchive } = action;

        // Redirect to login if we're trying to show the archive
        if (!isLoggedIn) {
          const referrer = {
            ...location,
            state: {
              action,
            },
          };
          history.push('/login', { referrer });
        } else {
          if (showSportArchive) {
            this.replaceActionState();
            showSportArchiveDialog();
          }

          if (showAtgArchive) {
            this.replaceActionState();
            showAtgArchiveDialog();
          }
        }
      }
    }

    onCreateSportBet = sportBetParams => {
      this.props.history.push('/sport', { betParams: sportBetParams });
    };

    onCreateAtgBet = atgBetParams => {
      this.props.history.push('/', { atgBetParams: atgBetParams });
    };

    onShowSportArchive = () => {
      this.replaceActionState({ showSportArchive: true });
    };

    onShowAtgArchive = () => {
      this.replaceActionState({ showAtgArchive: true });
    };

    onShowJokerWiz = () => {
      this.props.history.push('/', {
        jokerWizParams: { showWiz: true },
      });
    };

    replaceActionState(action) {
      this.setState({ action });
    }

    setSidebarStatType(sidebarStatType) {
      this.setState({ sidebarStatType });
    }

    // TODO - loader when loading async apps/creating bets
    render() {
      const {
        isLoggedIn,
        isAtgArchiveDialogActive,
        isErrorDialogActive,
        isSportArchiveDialogActive,
        location,
        history,
      } = this.props;
      const { sidebarStatType } = this.state;

      const atgBetParams = location.state?.atgBetParams;
      const jokerWizParams = location.state?.jokerWizParams;

      const statMonth = new Date().getMonth() + 1;
      const statYear = new Date().getFullYear();

      return (
        <PageBody fullWidth alignTo="menu">
          <SelectedGamePopupAsyncApp />
          <PageMeta title={getText('title-calendar')} theme="calendar" />
          <div className="calendar">
            <Ad placement="panorama" />
            <ContentWrapper>
              <div className="calendar-layout">
                <div className="main-column">
                  <ErrorBoundary>
                    <JackpotContainer
                      onCreateAtgBet={this.onCreateAtgBet}
                      onCreateSportBet={this.onCreateSportBet}
                    />
                  </ErrorBoundary>

                  <ErrorBoundary>
                    <SportContainer
                      onCreateBet={this.onCreateSportBet}
                      onShowArchive={this.onShowSportArchive}
                    />
                  </ErrorBoundary>

                  <ErrorBoundary>
                    <AtgContainer
                      onCreateBet={this.onCreateAtgBet}
                      onShowArchive={this.onShowAtgArchive}
                      onShowJokerWiz={this.onShowJokerWiz}
                    />
                  </ErrorBoundary>
                </div>

                <div className="aside-column">
                  <ErrorBoundary>
                    <TopProfitAsyncApp
                      month={statMonth}
                      onChange={e => this.setSidebarStatType(e)}
                      type={sidebarStatType}
                      year={statYear}
                    />
                  </ErrorBoundary>
                  <Ad placement="insider" />
                  <ErrorBoundary>
                    <BetTipsContainer
                      onCreateAtgBet={this.onCreateAtgBet}
                      onCreateSportBet={this.onCreateSportBet}
                    />
                  </ErrorBoundary>
                  <GamblingLiability />
                </div>
              </div>
            </ContentWrapper>
          </div>

          <ContentContainer />

          {isLoggedIn && isSportArchiveDialogActive && <AsyncSportDialogs />}

          {(atgBetParams || jokerWizParams || isAtgArchiveDialogActive) && (
            <AtgSubscriptionGatekeeper
              history={history}
              location={location}
              betParams={atgBetParams}
              jokerWizParams={jokerWizParams}
              errorDialogActive={isErrorDialogActive}
              archiveDialogActive={isAtgArchiveDialogActive}
            />
          )}
          <LiveInvite />
        </PageBody>
      );
    }
  },
);
